import { useFlags as useLaunchDarkly } from 'launchdarkly-react-client-sdk';

export type KoddiFlags = {
    /**   
               ___
            .-9 9 `\
          =(:(::)=  ;
            ||||     \
            ||||      `-.
           ,\|\|         `,
          /                \
         ;                  `'---.,
         |                         `\
         ;                     /     |
         \                    |      /
          )           \  __,.--\    /
       .-' \,..._\     \`   .-'  .-'
      `-=``      `:    |   /-/-/`
                   `.__/
    this is the typesafe walrus protector of our flags
     */

    campaignManagementToolEnabled: boolean;
    advertiserInsights: boolean;
    assetManagement: boolean;
    audienceReachEnabled: boolean;
    campaignHealthCheck: boolean;
    clientLevelSwapping: boolean;
    competitiveInsights: boolean;
    costPerMilli: boolean;
    customCampaignWizard: boolean;
    deleteCampaignOption: boolean;
    elevio: boolean;
    enableHelpCenter: boolean;
    enableChatBot: boolean;
    experienceCreationEnabled: boolean;
    experiencesConfiguration: boolean;
    hasAcceleratedPacingOption: boolean;
    hasClientCreation: boolean;
    hasMultipleEntityFeedsEnabled: boolean;
    hasTutorialEnabled: boolean;
    inventoryInsights: boolean;
    isDesignHuddleEnabled: boolean;
    isInsertionOrderEnabled: boolean;
    isToaEnabled: boolean;
    isAccountsFilterDropdownEnabled: boolean;
    isAdvertiserSpendLimitEnabled: boolean;
    isAllAdvertisersSelectedPayloadEnabled: boolean;
    isAudiencesEnabled: boolean;
    isAutomatedEntityAssignmentEnabled: boolean;
    isBidRecommendationsEnabled: boolean;
    isBudgetRecommendationsEnabled: boolean;
    isCampaignDuplicationEnabled: boolean;
    isCampaignReactivationEnabled: boolean;
    isHistoryDrawerEnabled: boolean;
    isIntegrationsEnabled: boolean;
    isRecommendationsDashboardEnabled: boolean;
    isTargetingAutomationEnabled: boolean;
    isWireTransfersEnabled: boolean;
    localizeWidget: boolean;
    networkInsights: boolean;
    notifications: boolean;
    oneTimePayment: boolean;
    pauseScheduleCampaigns: boolean;
    publisherDashboardMvp: boolean;
    savedReports: boolean;
    scheduledReports: boolean;
    showPriorPeriodToggle: boolean;
    isLDDrawerEnabled: boolean;
    isEntityLevelBiddingEnabled: boolean;
    observabilityDashboard: boolean;
    isFeaturesPageEnabled: boolean;
    internalReports: boolean;
    isComplexTargetingEnabled: boolean;
    isNewAdvertiserBlocksEnabled: boolean;
    isReactivationEnabled: boolean;
    isConfiguredCampaignFormEnabled: boolean;
    publisherFrontDoor: boolean;
    isSspEnabled: boolean;
    isTimezonesForAdvertisersEnabled: boolean;
    isRecommendationsV2Enabled: boolean;
    isAdvancedCachingEnabled: boolean;
    isIncrementalityEnabled: boolean;
    isIncrementalityDashboardEnabled: boolean;
    isPacingFunnelEnabled: boolean;
    isQualityScoreEnabled: boolean;
    priceFloor: boolean;
    loudSsp: boolean;
    isFrontdoorGranularGraphEnabled: boolean;
    isPublisherRecommendationsEnabled: boolean;
    isReservationsEnabled: boolean;
    isFinancialReportingEnabled: boolean;
    isCampaignCreativeLibraryEnabled: boolean;
    isAdGroupAutomatedFilterSelectionEnabled: boolean;
    isRealTimeBidAutomationEnabled: boolean;
    isIntegratedReportingEnabled: boolean;
    isReservationSettingsEnabled: boolean;
    isCreativeApprovalsEnabled: boolean;
    isFinancialReportingDebitTabEnabled: boolean;
    isAdvertiserMarketInsightsEnabled: boolean;
    isDesignHuddleV2Enabled: boolean;
    isPacingReportV2Enabled: boolean;
    promoCodes: boolean;
    isAdvertiserFrontdoorEnabled: boolean;
    isPublisherMarketInsightsEnabled: boolean;
    isIncompatibleWarningEnabled: boolean;
    isCreativeLibraryV2Enabled: boolean;
    isLifeCycleInsightsEnabled: boolean;
    areCwfDatesStrings: boolean;
    isAutomatedActionsEnabled: boolean;
    isAdGroupBudgetForecastingEnabled: boolean;
    isReservationEditingEnabled: boolean;
    isReservationsTabOnReportingEnabled: boolean;
    isPylonAiEnabled: boolean;
    isTransactionHistoryEnabled: boolean;
    isCwfForecastingEnabled: boolean;
    isFundingEnabled: boolean;
};

export const useKoddiFlags = (): KoddiFlags => {
    return useLaunchDarkly<KoddiFlags>();
};
